if (!customElements.get('hero-slider')) {
  customElements.define(
    'hero-slider',
    class HeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.media = Array.from(this.querySelectorAll('[data-media]'));
        this.controls = Array.from(this.querySelectorAll('[data-thumb]'));
        this.index = 0;
        this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.controls.forEach((control) =>
          control.addEventListener('click', () => {
            this.goTo(parseInt(control.dataset.thumb, 10));
            this.restart();
          })
        );

        this.querySelector('[data-prev]')?.addEventListener('click', () => {
          this.goTo(this.index - 1);
          this.restart();
        });
        this.querySelector('[data-next]')?.addEventListener('click', () => {
          this.goTo(this.index + 1);
          this.restart();
        });

        this.initSwipe();

        if (this.autoplay && !this.reducedMotion) {
          this.addEventListener('mouseenter', () => this.pause());
          this.addEventListener('mouseleave', () => this.resume());
          this.addEventListener('focusin', () => this.pause());
          this.addEventListener('focusout', () => this.resume());
          document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.resume()));
          this.play();
        }

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const target = this.media.indexOf(event.target);
            if (target > -1) {
              this.stop();
              this.goTo(target);
            }
          });
          document.addEventListener('shopify:block:deselect', () => this.autoplay && this.play());
        }
      }

      disconnectedCallback() {
        this.stop();
      }

      goTo(next) {
        const count = this.slides.length;
        if (!count) return;
        this.index = (next + count) % count;

        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.media.forEach((el, i) => el.classList.toggle('is-active', i === this.index));
        this.controls.forEach((control) => {
          const active = parseInt(control.dataset.thumb, 10) === this.index;
          control.classList.toggle('is-active', active);
          if (control.hasAttribute('aria-selected')) control.setAttribute('aria-selected', String(active));
        });

        // Restart the progress bar animation on the newly active thumbnail.
        if (this.classList.contains('is-playing')) {
          this.classList.remove('is-playing');
          void this.offsetWidth;
          this.classList.add('is-playing');
        }
      }

      play() {
        this.stop();
        this.classList.add('is-playing');
        this.classList.remove('is-paused');
        this.timer = setInterval(() => this.goTo(this.index + 1), this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.classList.remove('is-playing', 'is-paused');
      }

      pause() {
        if (!this.classList.contains('is-playing')) return;
        clearInterval(this.timer);
        this.classList.add('is-paused');
      }

      resume() {
        if (!this.classList.contains('is-paused')) return;
        this.play();
      }

      restart() {
        if (this.classList.contains('is-playing')) this.play();
      }

      // Swipe with a finger or drag with the mouse on the banner.
      initSwipe() {
        const area = this.querySelector('[data-banner]') || this;
        if (this.slides.length < 2) return;
        let startX = 0;
        let startY = 0;
        let tracking = false;
        let dragged = false;

        area.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          tracking = true;
          dragged = false;
          startX = event.clientX;
          startY = event.clientY;
        });

        area.addEventListener('pointermove', (event) => {
          if (!tracking || event.pointerType !== 'mouse') return;
          if (Math.abs(event.clientX - startX) > 8) area.classList.add('is-dragging');
        });

        const end = (event) => {
          if (!tracking) return;
          tracking = false;
          area.classList.remove('is-dragging');
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          dragged = true;
          this.goTo(this.index + (dx < 0 ? 1 : -1));
          this.restart();
        };
        area.addEventListener('pointerup', end);
        area.addEventListener('pointercancel', () => {
          tracking = false;
          area.classList.remove('is-dragging');
        });
        area.addEventListener('pointerleave', (event) => event.pointerType === 'mouse' && end(event));

        // A drag that ends on the button should not also open its link.
        area.addEventListener(
          'click',
          (event) => {
            if (!dragged) return;
            event.preventDefault();
            event.stopPropagation();
            dragged = false;
          },
          true
        );
        area.addEventListener('dragstart', (event) => event.preventDefault());
      }
    }
  );
}
